export const defaultConnectStatuses = ["Available", "Offline"];
